import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Icon } from "@iconify/react";
import { useLanguage } from "../../i18n/LanguageContext";

export const SelectMethodDialog = ({
  isOpen,
  onOpenChange,
  ableClose = true,
}: {
  isOpen: boolean;
  onOpenChange?: (v: boolean) => void;
  ableClose?: boolean;
}) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={ableClose}
        aria-describedby="subcribe"
        className="p-0 w-[92vw] max-w-md rounded-xl overflow-hidden shadow-2xl"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>{"Chọn hình thức đặt khám"}</DialogTitle>
          <DialogDescription>
            Hộp thoại chọn phương thức đặt khám
          </DialogDescription>
        </DialogHeader>
        {/* Head */}
        <div className="flex items-center justify-between p-3 border-b border-slate-200 bg-white">
          <div className="flex items-center space-x-3 ml-3 py-3">
            <div>
              <p className="text-lg font-bold text-slate-800 line-clamp-2">
                {t("chonhinhthucdatkham")}
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-3 space-y-4 bg-white">
          {/* Option 2: Đặt khám theo bác sĩ */}
          <button
            type="button"
            className="w-full text-left py-4 min-h-24 border-2 border-slate-200 rounded-2xl p-4 hover:border-emerald-500 transition-colors duration-200 group"
            onClick={() => navigate("/bac-si")}
          >
            <div className="flex items-center space-x-4">
              <Icon
                icon="healthicons:doctor-male-outline"
                className="w-10 h-10 text-green-600"
              />

              <div className="flex-1">
                <p className="text-base font-semibold text-slate-800 text-left">
                  {t("khamsangloctongquat")}
                </p>
                <p className="text-sm text-gray-400">
                  {t("khamsanglocmota")}
                </p>
              </div>
            </div>
          </button>

          {/* Option 1: Đặt khám theo thời gian */}
          <button
            type="button"
            className="w-full text-left py-4 min-h-24 border-2 border-slate-200 rounded-2xl p-4 hover:border-emerald-500 transition-colors duration-200 group"
            onClick={() => navigate("/phong-kham")}
          >
            <div className="flex items-center space-x-4">
              <Icon
                icon="healthicons:stethoscope-outline"
                className="w-10 h-10 text-green-600"
              />
              <div className="flex-1">
                <p className="text-base font-semibold text-slate-800 text-left">
                  {t("khamchuyenkhoa")}
                </p>
                <p className="text-sm text-gray-400">
                  {t("khamchuyenkhoamota")}
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="p-2"></div>
      </DialogContent>
    </Dialog>
  );
};
